<template>
  <!-- Modal -->
  <div v-if="this.$store.state.modal.modalConfirmarMultaGlosa.show === true" class="in show modal fade adicionarEvidencia" role="dialog">
    <div class="modal-dialog" role="document">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" v-on:click="closeModal()">&times;</button>
          <h3 class="modal-title">{{ `${infoMultas.modo === 'NOVO' ? 'Confirmar' : 'Exibir'} Aplicação de Multa e Glosa` }} </h3>

        </div>
        <div class="modal-body">
          <div class="modal-body alert-body icon-acoes btable">
            <div class="container-fluid">
              <div v-if="infoMultas.modo === 'NOVO'">
                <p class="text-danger"><i>* Campos obrigatórios</i></p>
                <br>
              </div>

              <div class="tabelaexibicao" v-if="Object.keys(infoMultas).length">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th class="text-center" scope="col">UF</th>
                      <th class="text-center" scope="col">Contrato</th>
                      <th class="text-center" scope="col">Mês</th>
                      <th class="text-center" scope="col">Ano</th>
                      <th class="text-center" scope="col">Multa</th>
                      <th class="text-center" scope="col">Glosa</th>
                      <th class="text-center" scope="col">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-center">{{ infoMultas.uf }}</td>
                      <td class="text-center">{{ infoMultas.tipo_imovel_servico }}</td>
                      <td class="text-center">{{ infoMultas.mes_sigla }}</td>
                      <td class="text-center">{{ infoMultas.ano }}</td>
                      <td class="text-center">
                        <money v-model="infoMultas.multa" v-bind="money" readonly class="formatacao-input-exibe-puro-texto"></money>
                      </td>
                      <td class="text-center">
                        <money v-model="infoMultas.glosa" v-bind="money" readonly class="formatacao-input-exibe-puro-texto"></money>
                      </td>
                      <td class="text-center">
                        <money v-model="infoMultas.total" v-bind="money" readonly class="formatacao-input-exibe-puro-texto"></money>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <b-container fluid>
                  <b-row class="b-input-component">
                    <b-col sm="3">
                      <label>Observação:</label>
                    </b-col>
                    <b-col v-if="infoMultas.modo === 'NOVO'" sm="12">
                      <b-form-textarea v-model="observacao" placeholder="Insira uma observação" rows="3" max-rows="6"></b-form-textarea>
                    </b-col>
                    <b-col v-else sm="9">
                      <p> {{ infoMultas.observacao }} </p>
                    </b-col>
                  </b-row>

                  <br>

                  <b-row class="b-input-component">
                    <div v-if="infoMultas.modo === 'NOVO'">
                      <b-col sm="3">
                        <label>Inserir Anexo *:</label>
                      </b-col>
                      <b-col sm="12">
                        <div class="form-group col-xs-12 col-sm-4 col-md-4 anexo-padding">
                          <input @change="configuraBotaoArquivo($event)" type="file" class="form-control" ref="file_anexo" id="btn-upload" value="">
                        </div>
                      </b-col>
                    </div>

                    <div v-else>
                      <b-col sm="3">
                        <label>Anexo:</label>
                      </b-col>
                      <b-col sm="9">
                        <div v-if="infoMultas.nome_arquivo">
                          <a v-on:click="downloadAnexoMultaGlosa(infoMultas.nome_arquivo)" href="javascript:void(0)" data-toggle="listarGlosas">
                            Download
                          </a>
                        </div>

                        <div v-else>
                          <p> Nenhum anexo adicionado </p>
                        </div>
                      </b-col>
                    </div>
                  </b-row>
                </b-container>

              </div>
              <div v-else>
                <h4 class="text-center">Nenhuma multa e/ou glosa encontrada para este contrato.</h4>
              </div>
            </div>
          </div>
        </div>
        <!-- modal-footer -->
        <div class="modal-footer" v-if="controlerBtnSubmit && novoFechamento">
          <button type="button" class="btn btn-submit" v-on:click="closeModal()">Cancelar</button>
          <button type="button" class="btn btn-primary btn-submit" v-on:click="salvarConfirmacaoMultaGlosa()" v-if="controlerBtnSubmit">Confirmar</button>
          <button type="button" class="btn btn-primary btn-submit" disabled v-else><i class='fa fa-refresh fa-spin'></i> aguarde...</button>
        </div><!-- ./moda-footer -->

        <div class="modal-footer" v-else>
          <button type="button" class="btn btn-submit" v-on:click="closeModal()">Cancelar</button>
        </div><!-- ./moda-footer -->
      </div>
    </div>
  </div>
</template>

<script>
import { Money } from 'v-money'

export default {
  props: ['multas'],
  data() {
    return {
      env: process.env,
      infoMultas: [],
      arquivo_anexo: null,
      observacao: '',
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      controlerBtnSubmit: true,
      novoFechamento: true
    }
  },
  components: {
    Money
  },
  mounted: function () {
    this.defineContrato()
  },
  watch: {
    multas: function () {
      this.defineContrato()
    }
  },
  methods: {
    defineContrato: function () {
      this.infoMultas = this.multas.dados ? this.multas.dados : []
      this.novoFechamento = this.infoMultas.modo === 'NOVO'
    },
    confirmarAcao: function () {
      return confirm('Confirma esta ação?')
    },
    salvarConfirmacaoMultaGlosa() {
      let vm = this
      if (!this.confirmarAcao()) {
        return
      }
      this.controlerBtnSubmit = false
      if (this.arquivo_anexo !== null) {
        this.$axios.post(`${this.env.FINANCEIRO.SLA}/salvarConfirmacaoMultaGlosa`, this.getFormRequest(), {
          headers: {
            'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          vm.finalizaPosConclusaoFechamentoMultaGlosa()
        }).catch(error => {
          vm.controlerBtnSubmit = true
          console.log(error)
        })
      } else {
        this.$store.commit('setAlert', { msg: `Campo de anexo deve ser preenchido!`, status: false, show: true })
        vm.controlerBtnSubmit = true
      }
    },
    getFormRequest() {
      let formData = new FormData()
      formData.append('usuario', this.$store.state.login.loginUsuario.usuario.name)
      formData.append('email', this.$store.state.login.loginUsuario.usuario.email)
      formData.append('uf_id', this.infoMultas.uf_id)
      formData.append('tipo_imovel_servico_id', this.infoMultas.tipo_imovel_servico_id)
      formData.append('mes_id', this.infoMultas.mes_id)
      formData.append('ano', this.infoMultas.ano)
      formData.append('valor_multa', this.infoMultas.multa)
      formData.append('valor_glosa', this.infoMultas.glosa)
      formData.append('total_multa_glosa', this.infoMultas.total)
      formData.append('observacao', this.observacao)
      formData.append('envio_confirmado', 1)
      formData.append('anexos_multa_glosa', this.arquivo_anexo)

      return formData
    },
    finalizaPosConclusaoFechamentoMultaGlosa() {
      this.controlerBtnSubmit = true
      let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
      this.$store.commit('setRefreshComponente', refreshComponentes)
      this.closeModal()
      this.$store.commit('setConfirmarMultaGlosa', { dados: null })
      this.$store.commit('setAlert', { msg: `Aplicação de multa e glosa confirmada com sucesso!`, status: true, show: true })
    },
    closeModal: function () {
      this.observacao = null
      this.$store.commit('setModalConfirmarMultaGlosa', { conteudo: null, show: false })
    },
    configuraBotaoArquivo: function (event) {
      this.arquivo_anexo = event.target.files[0]
    },
    downloadAnexoMultaGlosa: function (nomeArquivo) {
      let vm = this
      let dirBucket = 'anexosmultaglosa'
      this.$axios.get(`${this.env.FINANCEIRO.SLA}/downloadanexomultaglosa/${dirBucket}/${nomeArquivo}`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        if (response.data.mensagem) {
          vm.$store.commit('setAlert', { msg: response.data.mensagem, status: false, show: true })
          return
        }
        window.open(response.data.url, '_blank')
      })
      console.log(nomeArquivo)
    }
  }
}
</script>
<style scoped src="../css/modalConfirmarMultaGlosa.css" />



// WEBPACK FOOTER //
// ModalConfirmarMultaGlosa.vue?4929b258